import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, zip } from 'rxjs';
import { AuthService } from './core/auth/service/auth.service';
import { BaseService } from './core/base-service/service';
import { RoleAccessService } from './layout/shared/service';
import { RoleListServicePathConst, RoleMenuServicePathConst, RoleMyAccessServicePathConst } from './pages/role/shared/const';
import { RoleAccessModel, RoleMenuModel, RoleModel } from './pages/role/shared/model';

@Component({
	selector: 'app-root',
	template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit, OnDestroy {
	private subscribers: Subscription[];

	constructor(
		private authService: AuthService,
		private location: Location,
		private roleAccessService: RoleAccessService,
		private baseService: BaseService
	) {
	}

	ngOnInit(): void {
		this.subscribers = [];

		const isRedirecting = this.location.path().startsWith('/redirect');

		if (!isRedirecting) {
			this.fetchAllUserConfigs();
		}
	}

	fetchAllUserConfigs(): void {
		this.fetchSidebarNavigation();
		this.fetchUserCurrentRole();
		this.fetchAccessService();
	}

	private fetchAccessService(): void {
		const subs = this.baseService
			.getData(RoleMyAccessServicePathConst, RoleAccessModel, null, true)
			.subscribe((resp: RoleAccessModel[]) => {
				this.authService.roleAccesses = resp.map((value) =>
					value.code.toLowerCase()
				);
				this.roleAccessService.setRoleAccess(resp);
			});

		this.subscribers.push(subs);
	}

	private fetchSidebarNavigation(): void {
		const menuId = localStorage.getItem('superAppsBack.menuId');
		const url =
			RoleMenuServicePathConst + '?parentID=' + menuId + '&isSideBar=true';

		const subs = this.baseService
			.getData(url, RoleMenuModel, null, true)
			.subscribe((resp: RoleMenuModel[]) => {
				this.authService.menuTrees = resp;
			});

		this.subscribers.push(subs);
	}

	private fetchUserCurrentRole(): void {
		const roles: string[] = JSON.parse(
			localStorage.getItem('superAppsBack.roles')
		);

		const authorizedMenuIds: Set<string> = new Set();

		const mappedRoles = roles.map((role) => {
			const url = RoleListServicePathConst + '/' + role;

			return this.baseService.getData(url, RoleModel);
		});

		const subs = zip(...mappedRoles).subscribe({
			next: (responses: RoleModel[]) => {
				responses.forEach((response) =>
					response.menus.forEach(authorizedMenuIds.add, authorizedMenuIds)
				);
				this.authService.authorizedMenuIds = Array.from(authorizedMenuIds);
			}
		});

		this.subscribers.push(subs);
	}

	ngOnDestroy(): void {
		this.subscribers.forEach((each) => each.unsubscribe());
	}
}
